import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import React from 'react'

const { string, object } = PropTypes

export default class InputPlaceholderEducationAnimation extends React.Component {
    static propTypes = {
        css: object,
        text1: string,
        text2: string,
    }

    render() {
        const {
            placeholderText,
            device,
            rollInPlaceholderText,
            input,
            css,
            mobileRollInPlaceholderText,
            mobilePlaceholderText,
            showAnimationPlaceholder,
        } = this.props
        return (
            <div>
                <div
                    onClick={() => input.focus()}
                    className={showAnimationPlaceholder ? css[`${device}LearningPlaceholderContainer`] : css.hidden}
                >
                    <div className={css[`${device}LearningPlaceholderText`]}>
                        <p>{device === 'desktop' ? rollInPlaceholderText : mobileRollInPlaceholderText}</p>
                        <p>{device === 'desktop' ? placeholderText : mobilePlaceholderText}</p>
                        <p>{device === 'desktop' ? rollInPlaceholderText : mobileRollInPlaceholderText}</p>
                    </div>
                </div>
            </div>
        )
    }
}
